var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "사업분야",
      "sc": "에프원시큐리티는 전문가들로 이루어져 있습니다.",
      "tabActive": "솔루션 사업",
      "icon": "/images/sub/visual/sv2-icon.svg",
      "bg": "/images/sub/visual/sv2.png"
    }
  }), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5",
      "xl": "4",
      "data-aos": "fade-right"
    }
  }, [_c('h4', {
    staticClass: "sub-tit--md font-weight-bold"
  }, [_vm._v(" 솔루션 사업 ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7",
      "xl": "8",
      "data-aos": "fade-left"
    }
  }, [_c('p', {
    staticClass: "sub-tit--sm color-gray line-height-16"
  }, [_vm._v(" 솔루션 사업부는 UWSS, WEBCASTLE, WSFINDER, WMDS 등 소프트웨어개발, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 솔루션 영업을 주요업무로 하며, 제품의 설치 및 안내, A/S 서비스, 주기적인 업데이트 등 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 전반적인 사업을 담당합니다. "), _c('br'), _vm._v(" 또한, 일본, 베트남지사와 연계하여 솔루션을 수출하고, 해외 전시 참여 및 홍보 등을 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 진행합니다. ")])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section bg-grey mb-110 mb-md-140 mb-lg-180"
  }, [_c('v-container', [_c('v-img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "max-width": "1030",
      "src": "/images/sub/business/solution/solution-img.png",
      "data-aos": "fade"
    }
  }), _c('v-img', {
    staticClass: "d-block d-md-none mx-auto",
    attrs: {
      "max-width": "670",
      "src": "/images/sub/business/solution/solution-img-mo.png",
      "data-aos": "fade"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }